import React from 'react'
import './styles.scss'

export interface Props {
  value: number
}

export const EmissionBar = ({ value = 0 }: Props) => {
  return (
    <div className='barContainer'>
      <div className='bar' style={{ width: value + '%' }} />
    </div>
  )
}
